import { Heading, Text, VStack } from "@chakra-ui/react";
import { ArrowLeftIcon, WarningIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/UI/CustomButton";
import { DEFAULT_WIDTH } from "../../helpers/constant";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <VStack
      w={DEFAULT_WIDTH}
      mx="auto"
      spacing={6}
      textAlign="center"
      mt="32px"
    >
      <WarningIcon size={72} color="#0042BA" weight="duotone" />
      <Heading fontSize={["2xl", "3xl"]} fontFamily="Work Sans">
        {t("notFound.title")}
      </Heading>
      <Text fontSize={["md", "lg"]} color="gray.500" maxW="sm">
        {t("notFound.description")}
      </Text>
      <CustomButton
        leftIcon={<ArrowLeftIcon size={20} />}
        onClick={() => navigate("/teachings")}
        w={{ base: "80%", md: "70%" }}
        color="white"
      >
        {t("notFound.backToTeachings")}
      </CustomButton>
    </VStack>
  );
}
